import BackgroundColorPreview from './Background/BackgroundColorPreview';
import ImagePreview from './Image/ImagePreview';
import TextPreview from './Text/TextPreview';

import ButtonPreview from './Button/ButtonPreview';
import { ICanvasElement } from '@/interface/canvas';
import { screenCanvasElementTypes } from '@/constants/canvas';

const ElementsPreview = ({ elements }: IElementsPreviewProps) => {
  const renderElement = (element: ICanvasElement) => {
    switch (element?.type) {
      case screenCanvasElementTypes.BACKGROUND:
      case screenCanvasElementTypes.IMAGE:
        return <ImagePreview element={element} />;

      case screenCanvasElementTypes.TEXT:
        return <TextPreview element={element} />;

      case screenCanvasElementTypes.BUTTON:
        return <ButtonPreview element={element} />;
      case screenCanvasElementTypes.BACKGROUND_COLOR:
        return <BackgroundColorPreview element={element} />;
    }
  };
  return <>{elements && elements.map(ele => <>{renderElement(ele)}</>)}</>;
};

type IElementsPreviewProps = {
  elements?: Array<ICanvasElement>;
};
export default ElementsPreview;
